const DEVICE_ID_STORAGE_KEY = 'fcmDeviceId';

const generateDeviceId = () => {
  const randomPart = Math.random().toString(36).slice(2, 12);
  const timestampPart = Date.now().toString(36);
  return `device_${timestampPart}_${randomPart}`;
};

export const getOrCreateDeviceId = () => {
  try {
    const existing = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
    if (existing) {
      return existing;
    }

    const created = generateDeviceId();
    localStorage.setItem(DEVICE_ID_STORAGE_KEY, created);
    return created;
  } catch (error) {
    console.error('Erreur lors de la récupération/création du deviceId:', error);
    return generateDeviceId();
  }
};

export const getDeviceIdStorageKey = () => DEVICE_ID_STORAGE_KEY;
